import { render, staticRenderFns } from "./SessionLogout.vue?vue&type=template&id=27f7ac15&"
import script from "./SessionLogout.vue?vue&type=script&lang=js&"
export * from "./SessionLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports